var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-invoice concepts box wrapper-invoice-concepts" },
    [
      _c("div", { staticClass: "title-container is-flex" }, [
        _c(
          "h3",
          {
            staticClass:
              "title is-centered is-4 has-text-primary title-invice-concetps"
          },
          [_vm._v("\n      Conceptos\n    ")]
        ),
        _c(
          "div",
          { staticClass: "field is-centered" },
          [
            _c(
              "BTooltip",
              { attrs: { label: "Agregar partida", type: "is-success" } },
              [
                !_vm.disabled
                  ? _c(
                      "a",
                      {
                        staticClass: "button add-concept is-success is-rounded",
                        on: { click: _vm.addRow }
                      },
                      [_c("BIcon", { attrs: { icon: "plus" } })],
                      1
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "BTable",
        {
          attrs: {
            data: _vm.concepts,
            columns: _vm.columns,
            "opened-detailed": _vm.openedDetailed,
            detailed: "",
            "detail-key": "id"
          },
          on: { "details-close": _vm.onDetailsClose },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function(props) {
                return [
                  _c(
                    "span",
                    { class: { "header-label": props.column.label === "SKU" } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(props.column.label) + "\n      "
                      )
                    ]
                  ),
                  props.column.meta
                    ? _c("AppTooltip", { attrs: { label: props.column.meta } })
                    : _vm._e()
                ]
              }
            },
            {
              key: "default",
              fn: function(props) {
                return [
                  _c(
                    "BTableColumn",
                    { attrs: { field: "identificationNumber", internal: "" } },
                    [
                      _c("AppSelectSearch", {
                        staticClass: "product-service-key-field",
                        class: {
                          "selected-field":
                            _vm.selected === "sku-" + props.row.id
                        },
                        attrs: {
                          name: "identificationNumber",
                          placeholder: "S012321A",
                          value: _vm.skuObj(
                            props.row.identificationNumber,
                            props.row.id
                          ),
                          options: _vm.skuCatalog,
                          disabled: _vm.isLoading || _vm.disabled,
                          "on-search": _vm.onSearchSku,
                          taggable: true,
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          change: function($event) {
                            return _vm.onChangeIdentificationNumber(
                              $event,
                              props.row.id
                            )
                          },
                          focus: function($event) {
                            return _vm.onChangeSelected("sku-" + props.row.id)
                          },
                          blur: _vm.onClearSelected
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "description", internal: "" } },
                    [
                      _c("AppSelectSearch", {
                        staticClass: "product-service-key-field",
                        class: {
                          "selected-field":
                            _vm.selected === "description-" + props.row.id
                        },
                        attrs: {
                          name: "description",
                          placeholder: "Refrigerador",
                          value: _vm.descriptionObject(
                            props.row.description,
                            props.row.id
                          ),
                          options: _vm.descriptionCatalog,
                          disabled: _vm.isLoading || _vm.disabled,
                          "on-search": _vm.onSearchDescription,
                          taggable: true,
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          change: function($event) {
                            return _vm.onChangeDescription($event, props.row.id)
                          },
                          focus: function($event) {
                            return _vm.onChangeSelected(
                              "description-" + props.row.id
                            )
                          },
                          blur: _vm.onClearSelected
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "productServiceKey", internal: "" } },
                    [
                      _c("AppSelectSearch", {
                        staticClass: "product-service-key-field",
                        class: {
                          "selected-field":
                            _vm.selected ===
                            "product-service-key-" + props.row.id
                        },
                        attrs: {
                          name: "productServiceKey",
                          placeholder: "Clave de producto o servicio",
                          value: _vm.productServiceKeyObj(
                            props.row.productServiceKey
                          ),
                          options: _vm.productServiceKeyCatalog,
                          disabled: _vm.isLoading || _vm.disabled,
                          "on-search": _vm.onSearch,
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          change: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          focus: function($event) {
                            return _vm.onChangeSelected(
                              "product-service-key-" + props.row.id
                            )
                          },
                          blur: _vm.onClearSelected
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "unitKey", internal: "" } },
                    [
                      _c("AppSelectSearch", {
                        staticClass: "product-service-key-field",
                        class: {
                          "selected-field":
                            _vm.selected === "unit-key-" + props.row.id
                        },
                        attrs: {
                          name: "unitKey",
                          placeholder: "Clave de unidad",
                          options: _vm.unitKeyCatalog,
                          value: _vm.unitKeyObj(props.row.unitKey),
                          disabled: _vm.isLoading || _vm.disabled,
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          change: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          focus: function($event) {
                            return _vm.onChangeSelected(
                              "unit-key-" + props.row.id
                            )
                          },
                          blur: _vm.onClearSelected
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "quantity", internal: "" } },
                    [
                      _c("AppInputField", {
                        attrs: {
                          name: "quantity",
                          placeholder: "10",
                          min: "0.01",
                          step: "0.01",
                          type: "number",
                          disabled: _vm.isLoading || _vm.disabled,
                          value: props.row.quantity,
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          change: function($event) {
                            return _vm.onChange($event, props.row.id)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "unit", internal: "" } },
                    [
                      _c("AppInputField", {
                        attrs: {
                          name: "unit",
                          placeholder: "15.24",
                          type: "number",
                          step: "0.000001",
                          min: "0.000001",
                          disabled: _vm.isLoading || _vm.disabled,
                          value: props.row.unit,
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.onChange($event, props.row.id)
                          },
                          change: function($event) {
                            return _vm.onChange($event, props.row.id)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "taxes", internal: "" } },
                    [
                      _c("div", { staticClass: "is-centered" }, [
                        _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("toCurrency")(
                                  _vm.taxesAmount(props.row),
                                  _vm.voucherCurrency
                                )
                              ) +
                              "\n          "
                          )
                        ]),
                        _c(
                          "a",
                          {
                            staticStyle: {
                              "padding-left": ".25rem",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleDetail(props.row.id)
                              }
                            }
                          },
                          [
                            _c("BIcon", {
                              attrs: { icon: "pencil", type: "is-primary" }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "amount", internal: "" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("toCurrency")(
                              _vm.amountWithTaxes(props.row),
                              _vm.voucherCurrency
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "actions", internal: "" } },
                    [
                      _c("span", { staticClass: "actions" }, [
                        _vm.concepts.length > 1
                          ? _c(
                              "a",
                              {
                                staticClass: "button is-danger",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteRow(props.row.id)
                                  }
                                }
                              },
                              [
                                _c("BIcon", {
                                  attrs: {
                                    icon: "delete",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              }
            },
            {
              key: "detail",
              fn: function(detailProps) {
                return [
                  _c("ConceptTaxes", {
                    attrs: {
                      id: detailProps.row.id,
                      unit: +detailProps.row.unit,
                      quantity: +detailProps.row.quantity,
                      "tax-transfers": detailProps.row.taxTransfers,
                      "retained-taxes": detailProps.row.retainedTaxes,
                      "local-tax-transfers": detailProps.row.localTaxTransfers,
                      "local-tax-with-holds": detailProps.row.localTaxWithHolds,
                      disabled: _vm.disabled
                    }
                  })
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "footer" }, [
            _c("th", { attrs: { colspan: "5" } }),
            _c("th", [_vm._v("\n        Totales\n      ")]),
            _c("th", [
              _vm._v("\n        " + _vm._s(_vm.subTotalCurrency) + "\n      ")
            ]),
            _c("th", [
              _vm._v("\n        " + _vm._s(_vm.taxesCurrency) + "\n      ")
            ]),
            _c("th", [
              _vm._v("\n        " + _vm._s(_vm.totalCurrency) + "\n      ")
            ]),
            _vm.isOpen ? _c("tr", { attrs: { height: "300px" } }) : _vm._e()
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }